import { isNull, isArray, cloneDeep } from 'lodash'
import { EMPTY_DROPDOWN_LIST } from '../../../utils'
import { DEFAULT_GROUP_CONCAT_SEPARATOR } from './consts'

export const PROP_NODE_NUMBER = 'nodeNumber'

/**
 *
 * @param label
 * @param name
 * @returns {string|*}
 */
export function labelAndRefField(label, name) {
  if (name) return `${label}(${name})`
  else return label
}

/**
 *
 * @param name
 * @param field
 * @param number
 * @param color
 * @param textColor
 * @param fieldName
 * @param fieldId
 * @param diagramId
 * @returns {{relTable: *, fieldName: string, color: *, diagramId: *, nodeNumber: *, pattern: (*|null), rules: boolean, label: *, type: *, valueField: *, refTable: *, textColor: *, tableName: *, refField: *, relField: *, name: (*|string), alias: string, newNodeGenerate: boolean, idMongo: (null|string), fieldId: *, full: *}}
 */
export function nodeUploaded(name, field, number, color, textColor, fieldName, fieldId, diagramId) {
  field.label = field.label || ''
  fieldName = fieldName ? fieldName : `${field.label} - (${field.refField})`

  const label = `${field.refTable}(${number}) - ${labelAndRefField(field.label, field.refField)}`
  /**
   *
   * @type {{relTable: *, fieldName: string, color: *, diagramId: *, nodeNumber: *, pattern: (*|null), rules: boolean, label: *, type: *, valueField: ({default: string, type: String | StringConstructor}|{default: string, type: String | StringConstructor}|{default: string, type: String | StringConstructor}|{default: string, type: String | StringConstructor}|{default: string, type: String | StringConstructor}|string), refTable: *, textColor: *, tableName: *, refField: *, relField: *, name: (*|string), alias: string, newNodeGenerate: boolean, idMongo: (null|string), fieldId: *, full: *}}
   */
  const obj = {
    rules: true,
    tableName: name,
    name: fieldName,
    fieldName: label,
    fieldId: fieldId,
    label: field.label,
    alias: label,
    refTable: field.refTable,
    relTable: field.relTable,
    idMongo: field.idMongo,
    refField: field.refField,
    relField: field.relField,
    color: color,
    textColor: textColor,
    nodeNumber: number,
    newNodeGenerate: true,
    type: field.type,
    full: field,
    valueField: field.valueField || '',
    diagramId: diagramId,
    pattern: field.formats && field.formats.pattern ? field.formats.pattern : null,
  }

  return obj
}

/**
 *
 * @param tableName
 * @param diagramId
 * @param color
 * @param left
 * @param number
 * @param mainTable
 * @param name
 * @param idMongo
 * @returns {{mainTable: *, diagramId: *, color: *, left: *, nodeNumber: *, name: *, items: [], idMongo: *, key: string}}
 */
export function canvasNodeUpload(tableName, diagramId, color, left, number, mainTable, name, idMongo) {
  return {
    key: `${tableName}${number}`,
    diagramId: diagramId,
    color: color,
    left: left,
    nodeNumber: number,
    mainTable: mainTable,
    items: [],
    name: name,
    idMongo: idMongo,
  }
}

/**
 *
 * @param item
 * @returns {{options: *[], completed: boolean}}
 */
export function selectListKeyAndObject(item) {
  let list = cloneDeep(EMPTY_DROPDOWN_LIST)
  item.forEach((e, index) => {
    list.options.push({
      key: index,
      value: `${e.name} - (${e.mainTable})`,
      mainTable: e.mainTable,
      label: labelAndRefField(e.name, e.refField),
      idMongo: e.idMongo,
    })
  })
  return list
}

/**
 *
 * @param fieldList
 * @returns {{options: *[], completed: boolean}}
 */
export function selectListKeyAndObjectBind(fieldList) {
  let list = cloneDeep(EMPTY_DROPDOWN_LIST)
  fieldList.forEach((e, index) => {
    list.options.push({
      key: index + 1,
      value: `${e.refTable}(${e.nodeNumber}) - ${labelAndRefField(e.label, e.refField)}`,
    })
  })
  return list
}

/**
 *
 * @param rules
 * @returns {{options: *[], completed: boolean}}
 */
export function selectListKeyAndObjectFilter(rules) {
  const list = cloneDeep(EMPTY_DROPDOWN_LIST)

  if (!rules || !isArray(rules)) return list

  rules.forEach((rule, index) => {
    const item = list.options.find((i) => i.value === rule.label)
    if (!item) {
      list.options.push({ key: index + 1, value: rule.label, obj: rule })
    }
  })
  return list
}

/**
 *
 * @param list
 * @param mainTable
 * @returns {*|{}}
 */
export function listObjectSearch(list, mainTable) {
  if (!list || !isArray(list)) return {}
  return list.find((e) => e.mainTable === mainTable) || {}
}

export function isOnForm(mainTable, tableList) {
  let valid = false
  let result = tableList.find((search) => search.mainTable === mainTable)
  if (result) {
    valid = true
  }
  return valid
}

/**
 *
 * @param fieldList
 * @param max
 * @returns {number}
 */
export function nodeWidth(fieldList, max) {
  let number = 0
  fieldList.forEach((e) => {
    if (e.label.length > number) {
      number = e.label.length
    }
    if (number > max) {
      number = max
    }
  })
  return number
}

/**
 *
 * @param fieldList
 * @returns {number}
 */
export function nodeHeight(fieldList) {
  let number = 0
  fieldList.forEach((e, index) => {
    number = index
  })
  if (number === 1) {
    return (number = 50)
  } else if (number === 2) {
    return (number = 80)
  } else {
    return number * 23
  }
}

/**
 *
 * @param data
 * @param refTable
 * @param refField
 * @param nodeNumberFrom
 * @param relTable
 * @param relField
 * @returns {{}}
 */
export function linkGenerates(data, refTable, refField, nodeNumberFrom, relTable, relField) {
  let links = {}

  let to
  let from = linkHelper(data, refTable, refField, nodeNumberFrom, false)
  if (refTable !== relTable) {
    to = linkHelper(data, relTable, relField, null, true)
  } else {
    to = linkHelper(data, relTable, relField, nodeNumberFrom, true)
  }

  links.from = from.table
  links.fromPort = from.port
  links.to = to.table
  links.toPort = to.port
  links.join = 0
  links.fromMainTable = refTable
  links.fromField = refField
  links.toTableName = relTable
  links.fromNodeNumber = from.nodeNumber
  links.toNodeNumber = to.nodeNumber
  links.toField = relField
  links.isHighlighted = '#000'
  links.fromDiagramId = from.diagramId
  links.toDiagramId = to.diagramId

  return links
}

export function generateLinkData(diagram, data) {
  const link = {
    isHighlighted: '#000',
  }
  diagram.forEach((e) => {
    if (e.diagram.mainTable === data.fromMainTable && e.diagram.nodeNumber === data.fromNodeNumber) {
      e.diagram.items.forEach((field) => {
        if (field.refField === data.fromField) {
          link.fromPort = field.name
          link.from = e.diagram.key
          link.fromDiagramId = e.diagram.diagramId
        }
      })
    } else if (e.diagram.mainTable === data.toTableName && e.diagram.nodeNumber === data.toNodeNumber) {
      e.diagram.items.forEach((field) => {
        if (field.refField === data.toField) {
          link.toPort = field.name
          link.to = e.diagram.key
          link.toDiagramId = e.diagram.diagramId
        }
      })
    }
  })
  return link
}

/**
 *
 * @param data
 * @param table
 * @param field
 * @param nodeNumber
 * @param isRelTable
 * @returns {{}}
 */
function linkHelper(data, table, field, nodeNumber, isRelTable) {
  let tableAndPort = {}

  data.forEach((e) => {
    if (e.diagram.mainTable === table) {
      if (
        (!isRelTable && (isNull(nodeNumber) || e.diagram.nodeNumber === nodeNumber)) ||
        (isRelTable && (isNull(nodeNumber) || e.diagram.nodeNumber !== nodeNumber))
      ) {
        e.diagram.items.forEach((i) => {
          if (i.refField === field) {
            tableAndPort.port = i.name
            tableAndPort.table = e.diagram.key
            tableAndPort.diagramId = e.diagram.diagramId
            tableAndPort.nodeNumber = e.diagram.nodeNumber
          }
        })
      }
    }
  })
  return tableAndPort
}

/**
 *
 * @param data
 * @param id
 * @returns {number}
 */
function nodeNumberSearch(data, id) {
  let nodeNumber = 0
  data.forEach((e) => {
    if (e.diagram.diagramId === id) {
      nodeNumber = e.diagram.nodeNumber
    }
  })
  return nodeNumber
}

/**
 *
 * @param listobj
 * @param listData
 * @returns {number}
 */
export function nodeNumberGenerate(listobj, listData) {
  let number = 0
  if (listData) {
    listData.forEach((e) => {
      if (e.diagram.mainTable === listobj.mainTable) {
        number = e.diagram.nodeNumber
        ++number
      }
    })
  }
  return number
}

/**
 *
 * @param data
 * @param id
 * @returns {{fulldata: *, fieldLabel: *, nodeNumber: *, format: number, alias: string, aggregation: number, label: string, id: *, refName: *, table: *, tableName: *, order: number}}
 */
export function aggregationGenerate(data, id) {
  const label = `${data.refTable}(${data.nodeNumber}) - ${labelAndRefField(data.label, data.refField)}`
  let agg = {
    label: label,
    alias: label,
    table: data.refTable,
    tableName: data.refTable,
    nodeNumber: data.nodeNumber,
    refName: data.refName,
    id: id,
    fieldLabel: data.name,
    fulldata: data,
    order: -1,
    format: -1,
    aggregation: -1,
    groupConcatSeparator: DEFAULT_GROUP_CONCAT_SEPARATOR
  }
  return agg
}

/**
 *
 * @param data
 * @param table
 * @param port
 * @returns {{}}
 */
export function getLinkObj(data, table, port) {
  let obj = {}
  data.forEach((e) => {
    if (e.diagram.key === table) {
      e.diagram.items.forEach((i) => {
        if (i.name === port) {
          obj = i
        }
      })
    }
  })
  return obj
}

/**
 *
 * @param model
 * @param data
 * @returns {*}
 */
export function deleted(model, data) {
  model.model.forEach((diagram, index) => {
    if (diagram.diagram.diagramId === data.diagramId) {
      model.model.splice(index, 1)
    }
  })
  model.fieldList.forEach((field, index) => {
    if (data.diagramId === field[0].diagramId) {
      model.fieldList.splice(index, 1)
    }
  })
  model.links.forEach((link, index) => {
    if (link.fromDiagramId === data.diagramId || link.toDiagramId === data.diagramId) {
      model.links.splice(index, 1)
    }
  })
  model.rules.forEach((rule, index) => {
    if (rule.table === data.mainTable && rule.nodeNumber === data.nodeNumber) {
      model.rules.splice(index, 1)
    }
  })
  if (model.model.length <= 0) model.mainTable = {}

  return model
}

/**
 *
 * @returns {string}
 */
export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
